import PipeCard from "../../../pipe-common/PipeCard";
import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {Typography} from "@material-ui/core";
import {formatToFixed} from "../../../../helpers/NumberHelper";

const defaultIndicators = {
    universalInput: [{input: 1, filteredProcessValue: "---"}],
    controlLoop: [{loop: 1, heatPower: "---", workingProcessValue: "---", profileSetPointValue: "---"}]
};

function UniversalInput({item = undefined, xs = undefined, universalInput}) {
    if (!universalInput.length) return null;

    return (
        <Grid item={item} xs={xs} container spacing={2} direction={"row"} justify={"center"} alignItems={"center"}>
            <Grid item xs={12}>
                <Typography align={"center"} color={"textSecondary"} variant={"body1"}>Process Value</Typography>
            </Grid>
            {
                universalInput.map((input) => {
                        return (
                            <Grid key={`watlow-f4t-universal-input-${input.input}`} item>
                                <TextField
                                    id="filtered-process-value"
                                    label={`Input [${input.input}]`}
                                    value={`${formatToFixed(input.filteredProcessValue, 5)} °C`}
                                    inputProps={{
                                        readOnly: true,
                                        style: {textAlign: "center"}
                                    }}
                                />
                            </Grid>
                        );
                    }
                )
            }
        </Grid>
    )
}

function ControlLoop({item = undefined, xs = undefined, controlLoop}) {
    if (!controlLoop.length) return null;

    return (
        <Grid item={item}
              xs={xs}
              container
              spacing={2}
              direction={"row"}
              justify={"center"}
              alignItems={"center"}
        >
            {
                controlLoop.map((loop) => {
                        return (
                            <Grid key={`watlow-f4t-control-loop-${loop.loop}`}
                                  item
                                  container
                                  spacing={2}
                                  direction={"row"}
                                  justify={"center"}
                                  alignItems={"center"}
                            >
                                <Grid item xs={12}>
                                    <Typography align={"center"}
                                                color={"textSecondary"}
                                                variant={"body1"}
                                    >Control Loop [{loop.loop}]</Typography>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id="working-process-value"
                                        label={`Working Process Value`}
                                        value={`${formatToFixed(loop.workingProcessValue, 5)} °C`}
                                        inputProps={{
                                            readOnly: true,
                                            style: {textAlign: "center"},
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id="heat-power"
                                        label={`Heat Power`}
                                        value={`${formatToFixed(loop.heatPower, 5)} %`}
                                        inputProps={{
                                            readOnly: true,
                                            style: {textAlign: "center"}
                                        }}
                                        InputLabelProps={{shrink: true}}
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id="profile-set-point-value"
                                        label={`Profile Set Point Value`}
                                        value={`${formatToFixed(loop.profileSetPointValue, 5)} °C`}
                                        inputProps={{
                                            readOnly: true,
                                            style: {textAlign: "center"}
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        );
                    }
                )
            }
        </Grid>
    )
}

export default function WatlowF4TReadBack({pipe, data}) {
    const indicators = data ? {
        universalInput: data["universal_input"] ? Object
            .values(data["universal_input"])
            .flatMap(input => Object.values(input["inputs"]))
            .map((input, index) => ({
                input: index + 1,
                filteredProcessValue: input["filtered_process_value"]
            })) : defaultIndicators.universalInput,
        controlLoop: data["control_loop"] ? Object
            .values(data["control_loop"])
            .map((loop, index) => ({
                loop: index + 1,
                heatPower: loop["heat_power"],
                workingProcessValue: loop["working_process_value"],
                profileSetPointValue: loop["profile_set_point_value"]
            })) : defaultIndicators.controlLoop
    } : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container spacing={2} direction={"row"} justify={"space-between"} alignItems={"center"}>
                    <UniversalInput item xs={12} universalInput={indicators.universalInput}/>
                    <ControlLoop item xs={12} controlLoop={indicators.controlLoop}/>
                </Grid>
            }
        />
    );
}